import { Link } from "react-router-dom";
// @ts-ignore

const ColumnForDriver = ({}) => {
  return [
    {
      header: "نام",
      accessorKey: "name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "نام خانوادگی",
      accessorKey: "last_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "کد ملی",
      accessorKey: "national_code",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "شماره همراه ",
      accessorKey: "phone_number",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "پلاک",
      accessorKey: "license_plate",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "ظرفیت (تن)",
      accessorKey: "capacity_ton",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "نوع خودرو",
      accessorKey: "car_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "تاریخ ایجاد",
      accessorKey: "created_at",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
  ];
};

export default ColumnForDriver;
